import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationExtras,
  Params,
  Router,
} from '@angular/router';
import { Location } from '@angular/common';

import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import * as HttpStatus from 'http-status-codes';
import * as $ from 'jquery';

import { MainService } from '../../services/main.service';
import { BookingsService } from '../../services/bookings.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

const _ = require('underscore');

@Component({
  selector: 'app-book-visit',
  templateUrl: './book-visit.component.html',
  styleUrls: ['./book-visit.component.scss'],
})
export class BookVisitComponent implements OnInit {
  API = this.helper.getApi();
  domain = this.helper.getDomain();
  loadingIcon = 'assets/images/loading2.gif';
  active_step = 'visit';
  vals = {};
  formElements = [];
  data = {};
  allAvailableTimes = {};
  availableTimes = [];
  availableServices = [];
  filteredServices = [];
  dropdownSelection: string;
  dropdownSelection2: string;
  interval: any;
  fService: any;
  timeSelected: any;
  selectedId = undefined;
  query: any;
  clinics = [];
  bookingClinics = [];
  referral: any;
  first_booking_text: any;
  bookingIsExpert: string;
  bookingTherapist: any;
  availableTherapists = [];
  selectedTherapists = [];
  selectedTherapist = '';
  selectedTherapistsCount: number;
  clinicId: string;
  bookings: number;
  isFysio: boolean;
  selectedClinic: any;
  selectedDate: Date;
  selectedDate2: string;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy-mm-dd',
    inline: true,
    dayLabels: {
      su: 'Søn',
      mo: 'Man',
      tu: 'Tirs',
      we: 'Ons',
      th: 'Tor',
      fr: 'Fre',
      sa: 'Lør',
    },
    showClearDateBtn: true,
    monthLabels: {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'Maj',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Okt',
      11: 'Nov',
      12: 'Dec',
    },
    sunHighlight: false,
    showTodayBtn: false,
    todayBtnTxt: 'I dag',
    markCurrentMonth: true,
    markDates: [],
  };
  token: string;
  flowType: string;
  fisiqClinics: boolean;
  preselected_therapist: string;
  preselected_service: any;
  wrong = false;
  superClinicId: string;
  singleClinic: string;
  loading = false;
  showDescription = true;
  haveTherapists: boolean;
  noExperts: string;
  noBodyParts: string;
  type: string;
  showClearAll = false;
  therapistsWithTimes = [];
  dateLoading: boolean = false;
  currentUser: any = this.helper.getStorage('currentUser');
  allClinics: Array<any> = this.helper.getStorage('allClinics');
  allBookings: Array<any> = this.helper.getStorage('bookings');
  selectedService: string = this.helper.getStorage('selectedService');
  clinicTherapists: any = this.helper.getStorage('clinicTherapists');
  bookingBodyParts: any = this.helper.getStorage('bodyParts');
  readonly flowName: any = Constants.FLOW_TYPE;
  readonly clinicType = Constants.CLINIC_TYPE;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public mainService: MainService,
    public bookingsService: BookingsService,
    private location: Location
  ) {}

  ngOnInit() {
    this.loading = true;

    this.route.queryParams.subscribe((params) => {
      if (!this.allBookings || this.allBookings.length === 0) {
        this.bookingsService
          .getBookings(null, this.clinicType.custom)
          .subscribe((bookingsResponse) => {
            const bookings = bookingsResponse.response;

            if (bookings && bookings.length > 0) {
              localStorage.setItem('bookings', JSON.stringify(bookings));
              this.allBookings = this.helper.getStorage('bookings');
            } else {
              localStorage.setItem('bookings', JSON.stringify([]));
              this.allBookings = [];
            }

            this.paramActions(params);
          });
      } else {
        this.paramActions(params);
      }
    });

    if (Array.isArray(this.clinicTherapists)) {
      this.bookingTherapist = this.clinicTherapists;
    } else {
      if (this.bookingTherapist) {
        this.bookingTherapist.push(this.clinicTherapists);
      }
    }

    const data = this.data;
    const formElements = [
      {
        key: 'insuranceCompany',
        controlType: 'dropdown',
        value: data['insuranceCompany'],
      },
    ];

    formElements.map((element) => (this.vals[element.key] = element.value));

    this.formElements = formElements;

    if (this.currentUser.data.insuranceCompany) {
      this.dropdownSelection2 = this.currentUser.data.insuranceCompany;
    } else {
      this.dropdownSelection2 = '- Ingen -';
    }

    this.selectedClinic = this.allClinics.filter(
      (el) => el.id === this.clinicId
    );

    if (this.selectedClinic[0]) {
      this.referral = this.selectedClinic[0].referral;
      // this.first_booking_text = this.selectedClinic[0].first_time_booking_text;
      let textItem = _.find(this.selectedClinic[0].booking_texts, t => t.step === 'step_consultation' && t.step_context === 'ctx_first_booking' && t.text_type === 'content');
      if (textItem && textItem.text)
        this.first_booking_text = textItem.text;
    }
  }

  paramActions(params) {
    this.clinicId = Array.isArray(params.clinics)
      ? params.clinics[0]
      : params.clinics;

    if (params.type) {
      this.flowType = params.type;
    }

    this.query = params;

    this.clinics.push(params.clinics);

    this.singleClinic = params.singleClinic;
    this.superClinicId = params.superClinicId;
    this.bookingClinics = params.clinics;
    this.bookingIsExpert = params.isExpert;
    this.bookingTherapist = this.clinicTherapists
      ? this.clinicTherapists.toString().toLowerCase()
      : null;
    this.dropdownSelection = params.behandling;
    this.bookings = params.bookings;
    this.fService = params.service;
    this.noExperts = params.noExperts;
    this.noBodyParts = params.noBodyParts;
    this.type = params.type;

    if (params.bookingToken) {
      this.token = params.bookingToken;
    }

    if (params.type === 'fysiq' || params.type === this.flowName.aalborg) {
      this.fisiqClinics = true;
    }

    this.haveTherapists = Boolean(this.clinicTherapists);
    this.preselected_therapist = params.preselected_therapist;

    this.selectTherapists();
    this.getTherapistServices();
    this.getAvailableTimes();
    this.getAvailableServices();
  }

  preselectService(services) {
    if (services && services.length > 0) {
      if (this.selectedService) {
        let preselected = services.find(
          (service) => service.service_name === this.selectedService
        );

        this.preselected_service = preselected;

        if (preselected) {
          this.setDropdownSelection(this, preselected);
        }
      }
    }
  }

  chooseTime(therapist: any) {
    if (this.selectedTherapist !== therapist.id) {
      this.availableTherapists = [therapist];
      this.selectedTherapist = therapist.id;
    } else {
      this.availableTherapists = this.selectedTherapists;
      this.selectedTherapist = '';
      this.showClearAll = true;
    }
   

    this.getAvailableTimes();
  }

  extractTherapists(ids, therapists) {
    const array = [];

    ids.map((therapist) => {
      therapists.map((aTherapist) => {
        if (aTherapist.id === therapist) {
          array.push(aTherapist);
        }
      });
    });

    return array;
  }

  bookVisit() {
    const time_set = document.getElementsByClassName('time-set');
    let time_id;

    if (time_set[0]) {
      time_id = time_set[0].getAttribute('id');
    }

    this.queryVisitParams();

    const summary = {
      bodyparts: this.bookingBodyParts.toString(),
      behandling: this.dropdownSelection,
      insurance: this.dropdownSelection2,
      treatment: this.fService,
    };

    const currentTime = this.availableTimes.find(
      (time) => time._id === time_id
    );

    if (!currentTime) {
      return;
    }

    const therapists = this.extractTherapists(
      this.timeSelected.therapistId,
      this.availableTherapists
    );
    const clinic = this.allClinics.filter(
      (clinic) => clinic.id === this.bookingClinics[0]
    )[0];

    const data = {
      cpr: this.currentUser.data.CPRNumber,
      therapist: therapists[0].id,
      therapistData: therapists[0],
      client: this.currentUser.data.complimentaId,
      clientName: this.currentUser.data.firstName,
      clinicName: clinic.name,
      clinicAddress: clinic.address,
      clinicCity: clinic.city,
      clinicPost: clinic.post_code,
      clinicRegion: clinic.region,
      clinicPhone: clinic.phone,
      clinic: this.bookingClinics[0],
      comment: JSON.stringify(summary),
      from: this.timeSelected.from,
      to: this.timeSelected.to,
      flow_url: window.location.search,
    };

    this.bookingsService
      .makeBooking(data)
      .subscribe(this.handleBookingSuccess.bind(this));

    document.querySelector('.booking-steps').scrollIntoView({
      behavior: 'smooth',
    });
  }

  queryVisitParams() {
    this.route.queryParams.subscribe((params: Params) => {
      this.bookingClinics = params['clinics'];

      if (!Array.isArray(this.bookingClinics)) {
        this.bookingClinics = [this.bookingClinics];
      }

      this.bookingTherapist = this.clinicTherapists;
    });

    if (!Array.isArray(this.bookingBodyParts)) {
      this.bookingBodyParts = [this.bookingBodyParts];
    }
  }

  handleBookingSuccess(bookingResponse) {
    if (bookingResponse.status === HttpStatus.OK) {
      const code = bookingResponse.response.statusCode;

      if (code === HttpStatus.CREATED) {
        this.bookIfFysiq(bookingResponse);
      }
    } else {
      console.error('Error', bookingResponse);
    }
  }

  bookIfFysiq(bookingResponse) {
    if (this.fisiqClinics) {
      let params = {
        clinics: this.bookingClinics[0],
        type: this.flowType,
        bookingId: bookingResponse.response.id,
        bookings: this.bookings,
        singleClinic: this.singleClinic,
        service: this.fService,
        noExperts: this.noExperts,
        noBodyParts: this.noBodyParts,
      };

      // if superclinic and superclinic + service flow, send params to next page
      if (this.superClinicId) {
        params['superClinicId'] = this.superClinicId;
      }

      if (this.token) {
        params['bookingToken'] = this.token;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      this.router.navigate(
        ['/booking-success/' + bookingResponse.response.id],
        navigationExtras
      );
    } else {
      this.router.navigate(['/booking-success/' + bookingResponse.response.id]);
    }
  }

  getTherapistServices() {
    this.route.queryParams.subscribe((params: Params) => {
      this.selectedTherapist = this.clinicTherapists;
    });
  }

  getAvailableServices() {
    this.availableServices = [];

    this.mainService
      .getServices(this.clinics.toString(), this.fService)
      .subscribe(this.handleServiceSuccess.bind(this));
  }

  handleServiceSuccess(servicesResponse) {
    const all_services = [].concat(...servicesResponse.response);

    // sort services
    all_services.sort((a, b) => {
      return a[1] > b[1] ? 1 : -1;
    });

    // if aalborg flow, show only one service
    if (this.flowType === this.flowName.aalborg) {
      this.filteredServices = all_services;
    }

    // if no aalborg flow, filter first time booking services
    if (this.flowType !== this.flowName.aalborg) {
      this.isFysio = true;

      this.filterFK(this.allBookings, all_services);
    }

    // filter expert services
    this.filterExpert();

    if (this.filteredServices && this.filteredServices.length === 0) {
      this.wrong = true;
    } else {
      this.wrong = false;

      setTimeout(() => {
        this.preselectService(this.filteredServices);
      }, 0);
    }
  }

  filterExpert() {
    if (this.bookingIsExpert === 'false') {
      this.filteredServices = this.filteredServices.filter(
        (service) => service.service_type !== 'KX'
      );
    } else {
      this.filteredServices = this.filteredServices.filter(
        (service) => service.service_type === 'KX'
      );
    }
  }

  filterFK(fkBooking, allServices) {
    if (fkBooking.length > 0) {
      this.filteredServices = allServices.filter(
        (service) => service.is_fk === 0
      );
    } else {
      const services = this.filteredServices.filter(
        (service) => service.is_fk === 1
      );

      if (services && services.length === 0) {
        this.filteredServices = allServices;
      } else {
        this.filteredServices = services;
      }
    }
  }

  buildClinicsQuery() {
    return '?clinics=' + this.clinics.join('&clinics=');
  }

  sortTherapists(therapists) {
    therapists.sort(function (therapist_1, therapist_2) {
      if (therapist_1.priority < therapist_2.priority) return -1;
      if (therapist_1.priority > therapist_2.priority) return 1;

      if (therapist_1.name > therapist_2.name) return 1;
      if (therapist_1.name < therapist_2.name) return -1;
    });
  }

  selectTherapists() {
    this.mainService
      .getTherapists(this.clinics.toString(), this.clinicType.single)
      .subscribe(this.handleTherapistsSuccess.bind(this));
  }

  handleTherapistsSuccess(therapistsResponse) {
    if (therapistsResponse.status === HttpStatus.OK) {
      this.filterPreselected(therapistsResponse);

      // show only selected service therapist
      this.showSelected();

      this.availableTherapists.map((therapist) => {
        if (therapist.picture.includes('person_placeholder.jpg')) {
          therapist.picture = this.domain + 'assets/icons/placeholder.svg';
        }
      });

      this.selectedTherapistsCount = this.availableTherapists.length;

      this.sortBy();

      if (this.selectedTherapists.length === 1) {
        setTimeout(() => {
          this.chooseTime(this.selectedTherapists[0]);
        }, 0);
      }

      this.getAvailableTimes();
    } else {
      console.error('Error', therapistsResponse);
    }
  }

  showSelected() {
    const therapists = [];

    this.selectedTherapists.map((selected_therapist) => {
      selected_therapist.services.map((service) => {
        if (
          service.service_name === this.selectedService &&
          therapists.find(
            (therapist) => therapist.id === selected_therapist.id
          ) === undefined
        ) {
          therapists.push(selected_therapist);
        }
      });
    });

    this.selectedTherapists = therapists;
    this.availableTherapists = this.selectedTherapists;
  }

  sortBy() {
    if (this.selectedTherapists.length === 0) {
      this.haveTherapists = false;
    } else {
      const therapists_0_priority = this.selectedTherapists.filter(
          (therapist) => therapist.priority === 0
        ),
        therapists_not_0_priority = this.selectedTherapists.filter(
          (therapist) => therapist.priority !== 0
        );
      this.sortTherapists(therapists_0_priority);

      this.sortTherapists(therapists_not_0_priority);

      this.selectedTherapists = therapists_not_0_priority.concat(
        therapists_0_priority
      );
    }
  }

  filterPreselected(therapistsResponse) {
    if (
      this.preselected_therapist === 'true' &&
      this.allBookings &&
      this.allBookings.length > 0
    ) {
      this.selectedTherapists = therapistsResponse.response.filter(
        (therapist) =>
          therapist.id ===
          this.allBookings[this.allBookings.length - 1].therapistData.id
      );
    } else {
      if (this.bookingTherapist) {
        this.selectedTherapists = therapistsResponse.response.filter(
          (therapist) => this.bookingTherapist.includes(therapist.id)
        );

        this.selectedTherapists = this.selectedTherapists.filter(
          (therapist) =>
            therapist.services.filter(
              (service) => service.treatment_type_id === this.fService
            ).length !== 0
        );

        this.selectedTherapists.sort(
          (a, b) =>
            this.bookingTherapist.indexOf(a.id) -
            this.bookingTherapist.indexOf(b.id)
        );
      }
    }
  }

  buildDate(yyyy, mm, dd) {
    let day = String(dd);

    if (dd < 10) {
      day = '0' + dd;
    }

    let month = '';

    if (mm < 10) {
      month = '0' + mm;
    }

    return [yyyy + '-' + month + '-' + day];
  }

  setDropdownSelection(event: any, service) {
    this.selectedTherapist = '';
    this.selectedDate = null;
    this.selectedDate2 = null;

    const selection = service.service_name;

    if (this.fisiqClinics) {
      this.dropdownSelection =
        this.dropdownSelection !== selection ? selection : undefined;
    } else {
      this.dropdownSelection = selection;
    }

    this.interval = parseInt(service.duration ? service.duration : 30, 10) / 60;
    this.timeSelected = {};
    this.selectedId = undefined;
    this.availableTimes = [];
    this.setAvailableTimes();
  }

  setDropdownSelection2(event: any) {
    const selection = event.target.innerHTML;

    this.dropdownSelection2 = selection.trim();
  }

  goBack() {
    if (this.preselected_therapist === 'true') {
      this.location.back();
    } else {
      if (this.flowType === this.flowName.aalborg) {
        const params = {
          clinics: this.clinics,
          type: this.flowType,
          service: this.fService,
          superClinicId: this.superClinicId,
          token: this.token,
          singleClinic: this.singleClinic,
        };

        const navigationExtras: NavigationExtras = {
          queryParams: params,
        };

        this.router.navigate(['/body-parts'], navigationExtras);
      } else {
        const params = {
          preselected_therapist: this.preselected_therapist,
          isExpert: this.bookingIsExpert,
          bookings: this.bookings,
          clinics: this.clinics,
          type: this.flowType,
          service: this.fService,
          superClinicId: this.superClinicId,
          token: this.token,
          singleClinic: this.singleClinic,
          noExperts: this.noExperts,
          noBodyParts: this.noBodyParts,
        };

        const navigationExtras: NavigationExtras = {
          queryParams: params,
        };

        this.router.navigate(['/service'], navigationExtras);
      }
    }
  }

  getAvailableTimes() {
    const query = Object.assign(
      { physiotherapist: this.clinicTherapists },
      this.query
    );

    this.mainService
      .getTimes(query)
      .subscribe(this.handleTimesSuccess.bind(this));
  }

  handleTimesSuccess(timesResponse) {
    if (timesResponse.status === HttpStatus.OK) {
      const times = JSON.parse(timesResponse.response);

      this.allAvailableTimes = times;
      this.setAvailableTimes();

      this.loading = false;
    } else {
      this.loading = false;
    }
  }

  setAvailableTimes() {
    let data = this.allAvailableTimes;

    if (this.selectedTherapist !== '') {
      const filtered = Object.keys(data)
        .filter((key) => key === this.selectedTherapist)
        .reduce((obj, key) => {
          obj[key] = data[key];

          return obj;
        }, {});

      data = filtered;
    } else {
      const availableTherapistIds = this.selectedTherapists.map(
          (therapist) => therapist.id
        ),
        filtered = Object.keys(data).filter((key) =>
          availableTherapistIds.includes(key)
        ),
        filtered2 = filtered.reduce((obj, key) => {
          obj[key] = data[key];

          return obj;
        }, {});

      data = filtered2;
    }

    const times = {};

    this.therapistsWithTimes = [];

    this.sortByTherapist(data, times);
    this.setHighlightedDates(Object.keys(times));

    this.availableTimes = times[this.selectedDate2];

    this.arrangeTimes();

    if (this.availableTimes !== undefined) {
      this.showDescription = false;
    } else {
      this.showDescription = true;
    }
  }

  arrangeTimes() {
    if (this.availableTimes !== undefined) {
      const k = Object.keys(this.availableTimes);

      this.availableTimes = k.map((key) => {
        return this.availableTimes[key];
      });

      this.availableTimes.sort((a, b) =>
        a.startTime.localeCompare(b.startTime)
      );

      // select only therapists with selected date
      this.therapistsWithTimes = [];

      this.availableTimes.map((time) => {
        time.therapistId.map((therapist) => {
          this.therapistsWithTimes.push(therapist);
        });
      });
    }
  }

  sortByTherapist(therapistData, times) {
    for (const therapist in therapistData) {
      if (therapistData[therapist].length > 0) {
        this.therapistsWithTimes.push(therapist);
      }

      this.availableTimes = Object.keys(therapistData[therapist]).map((key) => {
        const el = therapistData[therapist][key],
          date = el.from.substring(0, 10);

        let start =
          parseInt(el.from.substring(11, 13), 10) +
          parseInt(el.from.substring(14, 16), 10) / 60;

        const end =
            parseInt(el.to.substring(11, 13), 10) +
            parseInt(el.to.substring(14, 16), 10) / 60,
          binterval = end - start,
          interval = this.interval;

        if (binterval >= interval) {
          if (!(date in times)) {
            times[date] = [];
          }
        }

        while (start + interval <= end) {
          const from =
            (Math.floor(start) < 10
              ? '0' + Math.floor(start)
              : Math.floor(start)) +
            ((start % 1) * 60 < 9.99
              ? ':0' + ((start % 1) * 60).toFixed(0)
              : ':' + ((start % 1) * 60).toFixed(0));

          start = start + interval;

          const to =
            (Math.floor(start) < 10
              ? '0' + Math.floor(start)
              : Math.floor(start)) +
            ((start % 1) * 60 < 9.99
              ? ':0' + ((start % 1) * 60).toFixed(0)
              : ':' + ((start % 1) * 60).toFixed(0));

          const id = date + ' ' + from + ':00';

          let timeSlot = {},
            full_from = date + ' ' + from + ':00',
            full_to = date + ' ' + to + ':00';

          timeSlot = {
            _id: id,
            startTime: from,
            endTime: to,
            from: full_from,
            to: full_to,
          };

          if (times[date]) {
            if (id in times[date]) {
              this.therapistsWithTimes.push(therapist);
              times[date][id]['therapistId'].push(therapist);
            } else {
              timeSlot['therapistId'] = [therapist];
              times[date][id] = timeSlot;
            }
          }
        }
      });
    }
  }

  sortDates(dates) {
    dates.sort(function (a, b) {
      a = a.toString().split('-');
      b = b.toString().split('-');

      return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
    });
  }

  setHighlightedDates(dates) {
    const alreadyHvBookingsCount =
      this.allBookings && this.allBookings.length > 0
        ? this.allBookings.filter((booking) => {
            return (
              booking.serviceData &&
              booking.serviceData.service_type &&
              booking.serviceData.service_type === 'HV'
            );
          }).length
        : 0;

    let all_dates = dates;
    let current_date = new Date();
    const today = current_date;
    const active_clinic = this.allClinics.find((clinic) => {
      return clinic.id === this.clinicId;
    });

    // sort by dates
    this.sortDates(all_dates);

    // if have first time booking, allow make bookings from this booking date
    if (
      this.allBookings &&
      this.allBookings.length > 0 &&
      this.flowType !== this.flowName.aalborg
    ) {
      const fk_booking = this.allBookings.find(
        (booking) => booking.serviceData && booking.serviceData.FK === 1
      );

      if (fk_booking) {
        const from_date = fk_booking.from;
        const booking_date = this.helper.reformatDate(from_date);

        if (booking_date > current_date) {
          const only_date = from_date.split(' ')[0];

          if (all_dates.length > 0) {
            if (all_dates.indexOf(only_date) === -1) {
              all_dates.push(only_date);
            }

            this.sortDates(all_dates);

            all_dates = all_dates.splice(all_dates.indexOf(only_date) + 1);
          }
        }
      }
    }

    // skip referral days
    if (
      all_dates.length > 0 &&
      this.preselected_service !== undefined &&
      this.preselected_service.service_type === 'HV' &&
      alreadyHvBookingsCount === 0
    ) {
      const referral_dates = [];
      const end = new Date(all_dates[0]);
      let start = new Date(all_dates[0]);

      // add referral days to start date
      end.setDate(end.getDate() + active_clinic.referral_days);

      // loop start and end days, format (YYYY-mm-dd) and push to array
      while (start <= end) {
        const mm =
          start.getMonth() + 1 >= 10
            ? start.getMonth() + 1
            : '0' + (start.getMonth() + 1);
        const dd =
          start.getDate() >= 10 ? start.getDate() : '0' + start.getDate();
        const yyyy = start.getFullYear();
        const date = yyyy + '-' + mm + '-' + dd;

        referral_dates.push(date);

        start = new Date(start.setDate(start.getDate() + 1));
      }

      // match all dates with referral dates and get days count to skip
      let skip_days_count = 0;

      referral_dates.map((date) => {
        all_dates.map((date2) => {
          if (date === date2) {
            skip_days_count = skip_days_count + 1;
          }
        });
      });

      // skip days
      if (active_clinic.referral === 1) {
        all_dates = all_dates.splice(skip_days_count);
      }
    }
    // if have first time booking, allow make bookings from this booking date
    this.setFkDate(current_date);
    this.setupDatePicker(all_dates, today);
  }

  setupDatePicker(all_dates, today) {
    const copy = JSON.parse(JSON.stringify(this.myDatePickerOptions));

    let highlighted = all_dates.map((date) => ({
      year: parseInt(date.substring(0, 4), 10),
      month: parseInt(date.substring(5, 7), 10),
      day: parseInt(date.substring(8), 10),
    }));

    highlighted.sort(function (a, b) {
      if (a.year === b.year) {
        if (a.month === b.month) {
          return a.day < b.day ? -1 : a.day > b.day ? 1 : 0;
        } else {
          return a.month < b.month ? -1 : 1;
        }
      } else {
        return a.year < b.year ? -1 : 1;
      }
    });

    copy.highlightDates = highlighted;

    copy.disableUntil = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()- 1,
    };
    this.myDatePickerOptions = copy;
  }

  setFkDate(current_date) {
    if (this.allBookings && this.allBookings.length > 0) {
      let booking_date = this.helper.reformatDate(this.allBookings[0].from);

      if (
        this.allBookings[0].serviceData &&
        this.allBookings[0].serviceData.FK === 1 &&
        booking_date > current_date
      ) {
        current_date = this.helper.reformatDate(this.allBookings[0].from);
        current_date.setDate(current_date.getDate() + 1);
      }
    }
  }

  onDateChanged(event: IMyDateModel) {
    this.selectedDate = new Date(event.formatted);
    this.selectedDate2 = event.formatted;
    this.timeSelected = {};
    this.selectedId = undefined;
    this.availableTimes = [];
    this.loading = true;
    this.showClearAll = true;

    this.getAvailableTimes();
  }

  selectTime(time: any) {
    if (this.selectedId === time._id) {
      this.timeSelected = {};
      this.selectedId = undefined;
    } else {
      this.timeSelected = time;
      this.selectedId = time._id;
    }

    // select only therapists with selected time
    this.therapistsWithTimes = [];

    this.availableTimes.map((available_time) => {
      if (available_time._id === time._id) {
        available_time.therapistId.map((therapist) => {
          this.therapistsWithTimes.push(therapist);
        });
      }
    });
  }

  clearAll() {
    this.showClearAll = false;
    this.availableTimes = [];
    this.showDescription = true;
    this.timeSelected = {};
    this.selectedId = undefined;

    this.therapistsWithTimes = [];
    this.selectedTherapist = '';

    this.getAvailableTimes();

    this.dateLoading = true;

    setTimeout(() => {
      this.dateLoading = false;
    }, 0);

    this.selectedDate = null;
    this.selectedDate2 = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/book-visit/book-visit.component.ts